export default __webpack_public_path__ + "static/media/49d6ca2565fb8005.30b85a8e326a5250ff766e1b24c26b06.svg";